import * as NewsApiActions from "@app/modules/news/actions/news-api.actions"
import { NewsTableItemModel } from "@app/modules/news/models/"
import { TableOverviewModel } from "@app/shared/models/table/table-overview.model"
import { TableStateModel } from "@app/shared/models/table/table-state.model"
import { applySortingOrDefault } from "@app/shared/utilities/overview-reducer.utilities"
import { createReducer, on } from "@ngrx/store"

const initialState: State = new TableOverviewModel<NewsTableItemModel>('sequenceNumber');

export interface State extends TableStateModel<NewsTableItemModel> { }

export const reducer = createReducer(initialState,
    on(NewsApiActions.GetOverview, (state) => ({ ...state, loading: true })),
    on(NewsApiActions.GetOverviewSuccess, (state, response) => ({ ...state, ...response, loading: false })),
    on(NewsApiActions.GetOverviewError, (state) => ({ ...state, loading: false })),
    on(NewsApiActions.FilterOverview, (state, { sorting, pagination }) => ({ 
        ...state, 
        sorting: applySortingOrDefault(initialState, sorting),
        pagination: { 
            ...state.pagination, 
            page: pagination.page,
            pageSize: pagination.pageSize
        } 
    })),
    on(NewsApiActions.ResetOverview,  () => ({ ...initialState }))
)

export const getLoading = (state: State) => state.loading;
export const getList = (state: State) => state.list;
export const getPagination = (state: State) => state.pagination;
export const getSorting = (state: State) => state.sorting;